import React, { useEffect, useState } from "react";
import {
  errorSnackbar,
  successSnackbar,
} from "@src/cloud-connect/snackbars/entities/snackbar-launcher";
import { TextButton } from "@src/components/atoms/buttons/text-button/text-button";
import {
  ToolTip,
  ToolTipPositionType,
} from "@src/components/atoms/tooltip/tooltip";
import { useI18N } from "@src/language/language-context";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";

interface CopyAccessTokenLinkNavProps {
  tooltipPosition: ToolTipPositionType;
}

export const CopyAccessTokenLinkNav = ({
  tooltipPosition,
}: CopyAccessTokenLinkNavProps) => {
  const i18n = useI18N();

  const texts = {
    linkText: i18n("modules.copyAccessTokenLink.linkText"),
    copySuccessText: i18n("modules.copyAccessTokenLink.copySuccessText"),
    copyErrorText: i18n("modules.copyAccessTokenLink.copyErrorText"),
    toolTipText: i18n("modules.copyAccessTokenLink.toolTipText"),
  };

  const authContext = useSelector(
    (state: RootState) => state.yourSlice.authContext,
  );

  const [accessToken, setAccessToken] = useState("");

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      successSnackbar(texts.copySuccessText);
    } catch (err) {
      console.error(`${texts.copyErrorText}: `, err);
      errorSnackbar(`${texts.copyErrorText}: ${err}`, 5000);
    }
  };

  const handleClick = () => {
    copyToClipboard(accessToken);
  };

  useEffect(() => {
    if (authContext) {
      setAccessToken(authContext.accessToken);
    }
  }, [authContext]);

  return (
    <>
      {accessToken && (
        <ToolTip content={texts.toolTipText} position={tooltipPosition}>
          <TextButton clickHandler={handleClick} text={texts.linkText} />
        </ToolTip>
      )}
    </>
  );
};
